// 公开 API 仍然走英文枚举值，Admin UI 仅在展示/下拉时映射成中文。

export const SECTOR_OPTIONS = [
  { value: "semiconductor", label: "半导体" },
  { value: "ai-driving",    label: "AI / 智驾" },
  { value: "biotech",       label: "生物医疗" },
  { value: "manufacturing", label: "智造 / 航天" },
] as const;

export const STAGE_OPTIONS = [
  { value: "listed",   label: "已上市" },
  { value: "pipeline", label: "Pre-IPO" },
  { value: "early",    label: "早期" },
] as const;

// 与 portfolio_projects.exit_status 自由文本兼容；空值表示未设置
export const EXIT_STATUS_OPTIONS = [
  { value: "hold",   label: "持有中" },
  { value: "locked", label: "锁定期" },
  { value: "exited", label: "已退出" },
] as const;

const toLabel = <T extends { value: string; label: string }>(opts: readonly T[]) =>
  Object.fromEntries(opts.map((o) => [o.value, o.label])) as Record<string, string>;

export const SECTOR_LABEL      = toLabel(SECTOR_OPTIONS);
export const STAGE_LABEL       = toLabel(STAGE_OPTIONS);
export const EXIT_STATUS_LABEL = toLabel(EXIT_STATUS_OPTIONS);
